import { useTranslation } from 'react-i18next';
import AddGroupUsersStyles from '../../AddGroupUsersModal/AddGroupUsersMoal.module.css';

const SearchBox = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className={AddGroupUsersStyles.searchSection}>
      <div className={AddGroupUsersStyles.searchWrap}>
        <svg
          className={AddGroupUsersStyles.searchIcon}
          width='14'
          height='14'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <circle cx='11' cy='11' r='8' />
          <line x1='21' y1='21' x2='16.65' y2='16.65' />
        </svg>
        <input className={AddGroupUsersStyles.searchInput} placeholder={t('screens.chat.search')} value={value} onChange={onChange} />
      </div>
    </div>
  );
};

export default SearchBox;
